import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { ItemMessageComponent } from './item-message.component';

@NgModule({
  declarations: [
    ItemMessageComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    MatIconModule,
  ],
  exports: [
    ItemMessageComponent,
  ],
})
export class ItemMessageModule { }
